import {Component, Input, OnInit, inject} from '@angular/core';
import {I18nService} from '../../../_services/gui/i18n.service';
import {reformatDate} from 'src/app/_utils/lang';
import {compareLastSaleDateAsc} from '../../../_utils/comparators';
import {Observable} from 'rxjs';
import {BizLumbSubTradeAccount, BizLumbSubTradeAccountDet} from '../../../_data/reports/lumbermens/lumbermens-business';
import {AsyncPipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-lumbermens-automated-trade-submission-det',
    templateUrl: './lumbermens-automated-trade-submission-det.component.html',
    styleUrls: ['./lumbermens-automated-trade-submission-det.component.scss'],
    imports: [AsyncPipe, TranslateModule]
})
export class LumbermensAutomatedTradeSubmissionDetComponent implements OnInit {

  @Input('lumbermensTradeAccount') account: BizLumbSubTradeAccount = {} as BizLumbSubTradeAccount;

  //Util methods used in the template
  reformatDate = reformatDate;
  
  i18nService = inject(I18nService);

  dets: BizLumbSubTradeAccountDet[];
  soldSinceDate: string;
  highestCreditEver: Observable<string>;

  ngOnInit() {
    this.dets = this.account.bizLumbSubTradeAccountDet?.sort(compareLastSaleDateAsc()) ?? [];
    this.soldSinceDate = reformatDate(this.dets[this.dets.length - 1]?.lastSaleDate);
    this.highestCreditEver = this.i18nService.formatCurrency(this.dets.map(d => d.highBalance).sort((a, b) => a - b).reverse()[0]);
  }

  getSic(): string {
    const sic = this.account.sicCode;
    const sicDesc = this.i18nService.currentLangShortCode === 'FR' ? this.account.sicFrenchDescription : this.account.sicEnglishDescription;
    return sic && sicDesc ? `${sic}/${sicDesc}` : null;
  }

  // This section you DON'T include the future amount in the total
  getTotalOwing(det: BizLumbSubTradeAccountDet): Observable<string> {
    const totalAmount = det.dueCurrent + det.due30 + det.due60 + det.due90 + det.due120;
    return this.i18nService.formatCurrency(totalAmount);
  }

}
